import {LOANS} from 'loans.module/common/domain/constants.loans';

class LoansDetailBasicCharacteristicsController {
  constructor($stateParams,$q, LoansOperationsService) {
    'ngInject';
    this.loanId = $stateParams.loanId;
    this.q = $q;
    this.loansOperationsService = LoansOperationsService;
    this.createTableFixed();
  }

  isArray(value) {
    return Array.isArray(value);
  }

  whatLoansDetailIs(loanType) {
    return this.loanId === loanType;
  }

  onGetLoanId() {
    return this.loanId === LOANS.ID.SOCIAL_HOUSING_LOAN;
  }

  isSocialAgreementHousingLoan() {
    return this.loanId === LOANS.ID.AGREEMENT_HOUSING_LOAN;
  }

  isSocialHousingLoan() {
    return this.loanId === LOANS.ID.SOCIAL_HOUSING_LOAN;
  }

  isTypeObject(description){
    return typeof description === 'object';
  }

  getTableColumns() {
    return this.datatable[this.loanId].years.length;
  }

  getMobileInterestRows() {
    const loanTable = this.datatable[this.loanId] || {};

    if (Array.isArray(loanTable.dataTableOnMobileApp)) {
      return loanTable.dataTableOnMobileApp;
    }

    const legacyKey = Object.keys(loanTable).find(key => key.indexOf('dataTableOn') === 0);
    return legacyKey ? loanTable[legacyKey] : [];
  }

  createTableFixed(){
    const httpSV = this.loansOperationsService.getInterestSV();
    const httpVC = this.loansOperationsService.getInterestVC();
    this.q.all([httpSV,httpVC]).then(values=>{
      this.socialHousingLoan = this.formatList(values[0].data.interestSV);
      this.agreementHousingLoan = this.formatList(values[1].data.interestVC);
    });
  }

  formatList(info){
    const auxList = [];
    let date = 0;
    info.forEach((element) => {
      date = Math.round((element.monthEnd - element.monthStart) / 12) + date;
      auxList.push({ date: 'Hasta ' + date + ' años', interest: element.interestType});
    });
    return auxList;
  }
}

export default LoansDetailBasicCharacteristicsController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailBasicCharacteristics/loansDetailBasicCharacteristics.controller.js